import { Reducer } from 'react'
import { Actions } from 'store/actions/common.action'
import * as ActionTypes from 'store/types/common.type'
import { RootReducerType } from '.'

export interface State {
    isLoading: boolean
    error?: string
    success?: string
}

const initialState: State = {
    isLoading: false
}

const commonReducer: Reducer<State, Actions> = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.COMMON_LOADING:
            return { ...state, isLoading: true, error: '', success: '' }
        case ActionTypes.COMMON_SUCCESS:
            return { ...state, isLoading: false, success: action.success }
        case ActionTypes.COMMON_ERROR:
            return { ...state, isLoading: false, error: action.error }
        case ActionTypes.COMMON_RESET:
            return initialState
        default:
            return state
    }
}

export const commonSelector = (state: RootReducerType) => state.common
export default commonReducer